module.exports = __webpack_public_path__ + "img/des-man-crowd.e1eb7118.jpeg";